import axios from 'axios';

export async function obtenerCuestionario(hash) {
  const response = await axios.get(`/cuestionario/${encodeURIComponent(hash)}`);
  return response.data.data;
}

export async function enviarCuestionario(hash, valoraciones) {
  const response = await axios.post(`/cuestionario/${encodeURIComponent(hash)}`, {
    valoraciones,
  });
  return response.data.data;
}
